import script from "./Bakersharing.vue?vue&type=script&setup=true&lang=js"
export * from "./Bakersharing.vue?vue&type=script&setup=true&lang=js"

import "./Bakersharing.vue?vue&type=style&index=0&id=1a52d538&lang=scss"

const __exports__ = script;

export default __exports__